(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name createPairing.controller:MissingItemsCtrl
     *
     * @description
     *
     */
    angular
        .module('createPairing')
        .controller('MissingItemsCtrl', MissingItemsCtrl);

    function MissingItemsCtrl($uibModalInstance, modalParams) {
        var vm = this;
        vm.ctrlName = 'MissingItemsCtrl';
        vm.model = {
            trainingList : modalParams.trainingList,
            flightList : modalParams.flightList
        }

        vm.closeMe = function () {
            $uibModalInstance.close();
        }
    }
}());
